export default __webpack_public_path__ + "static/media/error-circle.e5ed5302.svg";